/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetApiPublicBranchServicesQueryResponse, GetApiPublicBranchServicesQueryParams } from "../entities/GetApiPublicBranchServices";

function getGetApiPublicBranchServicesUrl() {
  const res = { method: 'GET', url: `/api/public/branch/services` as const }
  return res
}

/**
 * @description Получить доступные услуги (стрижки) выбранного филиала
 * @summary Получить услуги филиала
 * {@link /api/public/branch/services}
 */
export async function getApiPublicBranchServices(params: GetApiPublicBranchServicesQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetApiPublicBranchServicesQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetApiPublicBranchServicesUrl().url.toString(), params, ... requestConfig })
  return res.data
}